var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_vm._l((_vm.items),function(item){return [(item.path)?_c('div',[_c('router-link',{attrs:{"to":item.path}},[_c('div',{staticClass:"nav-item"},[_c('div',{staticClass:"nav-item-text blogtextbold"},[_vm._v(_vm._s(item.name))])])])],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }